import { createSlice } from "@reduxjs/toolkit"

const aggSlice = createSlice({
    name: 'agg',
    initialState: {
        region: "",
        displacement_reasons: [],
        global_annual_trend: [],
        annual_driver_trend: [],
        annual_region_trend: [],
        regional_Agg: [],
        country_Agg: [],
        operation_List: [],
        admin1: [],
        admin2: [],
        countries_List: [],
        regions_List: [],
        rounds: []

    },
    reducers: {
        setRegion(state, action) {
            state.region = action.payload ?? "";
        },

        setDisplacementReasons(state, action) {
            state.displacement_reasons = action.payload
        },
        setGlobalAnnualTrend(state, action) {
            state.global_annual_trend = action.payload
        },
        setAnnualDriverTrend(state, action) {
            state.annual_driver_trend = action.payload
        },
        setAnnualRegionTrend(state, action) {
            state.annual_region_trend = action.payload
        },
        setRegionalAgg(state, action) {
            state.regional_Agg = action.payload
        },
        setCountryAgg(state, action) {
            state.country_Agg = action.payload
        },
        setOperationList(state, action) {
            state.operation_List = action.payload
        },
        setAdmin1(state, action) {
            state.admin1 = action.payload
        },
        setAdmin2(state, action) {
            state.admin2 = action.payload
        },
        setCountriesList(state, action) {
            state.countries_List = action.payload
        },
        setRegionsList(state, action) {
            state.regions_List = action.payload
        },
        setRounds(state, action) {
            state.rounds = action.payload
        }


    }
});

export const aggSliceActions = aggSlice.actions;

export default aggSlice;
